import React, { Suspense, lazy } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import AppDownloadFloating from "@/components/AppDownloadFloating";

// Lazy-load sub-pages so they are only downloaded when navigated to
const Home = lazy(() => import("@/pages/Home"));
const AudiencePage = lazy(() => import("@/pages/AudiencePage"));
const PrivacyPolicy = lazy(() => import("@/pages/PrivacyPolicy"));
const RefundPolicy = lazy(() => import("@/pages/RefundPolicy"));
const TermsOfUse = lazy(() => import("@/pages/TermsOfUse"));
const Careers = lazy(() => import("@/pages/Careers"));
const Blogs = lazy(() => import("@/pages/Blogs"));
const BlogDetail = lazy(() => import("@/pages/BlogDetail"));
const ProductDetail = lazy(() => import("@/pages/ProductDetail"));
const ProductPassportDetail = lazy(() => import("@/pages/ProductPassportDetail"));
const NotFound = lazy(() => import("@/pages/NotFound"));

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppDownloadFloating />
      <Suspense fallback={<div className="min-h-screen bg-white"></div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:slug" element={<BlogDetail />} />
          <Route path="/product/:product_code" element={<Navigate to="/blogs" replace />} />
          <Route path="/product-passport/detail" element={<ProductPassportDetail />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="/:audience" element={<AudiencePage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
